export interface Coordinate {
  x: number;
  y: number;
}

class CanvasLine {
  private _ctx: any;
  private _shift = 0;
  private _list: any[] = [];
  private _coords: Coordinate[] = [];
  private _selected: Coordinate[] = [];

  constructor(data: {
    canvas: any;
    list: any[];
    coords: Coordinate[];
    selected: Coordinate[];
  }) {
    this._ctx = data.canvas.getContext('2d');
    this._shift = this._ctx.canvas.clientWidth / 2;
    if (data.list) this._list = data.list;
    if (data.coords) this._coords = data.coords;
    if (data.selected) this._selected = data.selected;

    this.setCoordinates(this._selected);
  }

  resetCanvas(canvas: any) {
    this._ctx = canvas.getContext('2d');
    this.setCoordinates(this._selected);
  }

  setCoordinates(selected: Coordinate[]) {
    const selectedCoords = [];
    this._selected = selected;

    for (let value of selected) {
      const index = this._list.indexOf(value);
      if (typeof index === 'number') {
        selectedCoords.push(this._coords[index]);
      }
    }

    if (selected.length < 2) {
      const lastCoords = this._coords[this._coords.length - 1];
      selectedCoords.push({
        x: this._coords[0].x,
        y: this._coords[0].y,
      });
      selectedCoords.push({
        x: lastCoords.x,
        y: lastCoords.y,
      });
    }

    selectedCoords.sort((a, b) => a.x - b.x);
    this.drawPath(selectedCoords);
  }

  drawPath(coords: Coordinate[]) {
    this._ctx.clearRect(
      0,
      0,
      this._ctx.canvas.clientWidth,
      this._ctx.canvas.clientWidth
    );
    for (let index in coords) {
      this._ctx.save();
      let startPoint;
      if (+index === 0) {
        const last = coords.length - 1;
        startPoint = coords[last];
      } else {
        startPoint = coords[+index - 1];
      }
      this.drawLine(
        coords[index].x,
        coords[index].y,
        startPoint.x,
        startPoint.y
      );
      this._ctx.restore();
    }
  }

  drawLine(X: number, Y: number, prevX: number = 0, prevY: number = 0) {
    X = X + this._shift;
    Y = Y + this._shift;
    prevX += this._shift;
    prevY += this._shift;
    if (prevX || prevY) {
      this._ctx.moveTo(prevX || 0, prevY || 0);
    }
    this._ctx.strokeStyle = 'white';

    this._ctx.beginPath();
    this._ctx.moveTo(prevX, prevY);
    this._ctx.lineTo(X, Y);
    this._ctx.stroke();

    prevX = X;
    prevY = Y;
  }
}

export default CanvasLine;
